import { lazy } from "react";

const AddExpense = lazy(() => import("../Component/ExmployeeExpence/AddExpence"));
const JuniorExpense = lazy(() => import("../Component/ExmployeeExpence/JuniorExpense"));

const expenseRoutes = [
  { path: "/add-expense", element: <AddExpense />, protected: true },
  { path: "/junior-expense", element: <JuniorExpense />, protected: true },
];

export default expenseRoutes;
